export default {
    setLastWaitlistEntry(state, entry) {
        state.lastWaitlistEntry = entry;
    },
};
